import { render, staticRenderFns } from "./AudioNoticeboard.vue?vue&type=template&id=749dccbe&scoped=true&"
import script from "./AudioNoticeboard.vue?vue&type=script&lang=js&"
export * from "./AudioNoticeboard.vue?vue&type=script&lang=js&"
import style0 from "./AudioNoticeboard.vue?vue&type=style&index=0&id=749dccbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749dccbe",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QBtn});
